import { render, staticRenderFns } from "./v-display-options.vue?vue&type=template&id=dca91136&scoped=true&"
import script from "./v-display-options.vue?vue&type=script&lang=js&"
export * from "./v-display-options.vue?vue&type=script&lang=js&"
import style0 from "./v-display-options.vue?vue&type=style&index=0&id=dca91136&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca91136",
  null
  
)

export default component.exports